var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`iconfont  ${_vm.name}`,style:(`font-size:${_vm.size}px`)})
}
var staticRenderFns = []

export { render, staticRenderFns }